/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_S6_P3Inputs */

const en_guide_json_schema_s6_p3 = /** @type {(inputs: Guide_Json_Schema_S6_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You do not need to describe everything at once. Start by requiring the handful of fields your code truly depends on, then tighten types and add constraints as the shape settles. A small schema that catches the common mistakes is more useful than an exhaustive one that never ships.`)
};

const ko_guide_json_schema_s6_p3 = /** @type {(inputs: Guide_Json_Schema_S6_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 것을 한 번에 기술할 필요는 없습니다. 코드가 정말로 의존하는 몇 개의 필드를 필수로 지정하는 데서 시작하고, 형태가 안정되면 타입을 조이고 제약을 더하세요. 흔한 실수를 잡아내는 작은 스키마가, 끝내 완성되지 않는 방대한 스키마보다 유용합니다.`)
};

const ja_guide_json_schema_s6_p3 = /** @type {(inputs: Guide_Json_Schema_S6_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてを一度に記述する必要はありません。コードが本当に依存する少数のフィールドを必須にすることから始め、形が定まってきたら型を締め、制約を加えましょう。よくある間違いを捉える小さなスキーマのほうが、決して完成しない網羅的なスキーマより役立ちます。`)
};

/**
* | output |
* | --- |
* | "You do not need to describe everything at once. Start by requiring the handful of fields your code truly depends on, then tighten types and add constraints a..." |
*
* @param {Guide_Json_Schema_S6_P3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_s6_p3 = /** @type {((inputs?: Guide_Json_Schema_S6_P3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_S6_P3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_s6_p3(inputs)
	if (locale === "ko") return ko_guide_json_schema_s6_p3(inputs)
	return ja_guide_json_schema_s6_p3(inputs)
});